// **  Initial State
const initialState = {
    stepId:"",
    routeInfo:{},
    items: [],
    relations: [],
    loading:true,
    errors:[],
    search:'',
    url:'productRoute',
    addUrl:'materialCreate',
    updateUrl:'materialUpdate',
    deleteUrl:'materialDelete',
    adding:{
        loading:false,
        isDone:false,
        errors:[]
    },
    updating:{},
    publish:{},
    request:{},
    apply:{},
    certify:{},
    receive:{},
    reset_password:{},
    delete_partner:{},
    deleting:{},
    undo:{}
}


const passportReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_PASSPORT_STEPS':
            return {
                ...state,
                loading:true, 
                errors:[] 
            }
        
        case 'FETCH_PASSPORT_STEPS_SUCCESS':
            return {
                ...state,
                items:action.data.refPassportSteps,
                routeInfo:action.data,
                stepId:action.data.id,
                loading:false, 
                errors:[] 
                
            }

        case 'FETCH_PASSPORT_STEPS_FAIL':
        return {
            ...state,
            loading:false, 
            errors:action.errors 
            
        }

        case 'ADD_PASSPORT_STEP':
            return {
                ...state,
                adding:{
                    loading:true, 
                    isDone:false,
                    errors:[] 
                }
            }
        
        case 'ADD_PASSPORT_STEP_SUCCESS':
            return {
                ...state,
                adding:{
                    loading:false, 
                    isDone:true,
                    errors:[] 
                },
                items:[...state.items, action.step]
            }

        case 'ADD_PASSPORT_STEP_FAIL':
            return {
                ...state,
                adding:{
                    loading:false, 
                    isDone:false,
                    errors:action.errors 
                }
            }
        case 'UPDATE_PASSPORT_STEP':
            return {
                ...state,
                updating:{
                    ...state.updating,
                    [action.id] : {
                        loading:true, 
                        isDone:false, 
                        errors:[] 
                    }
                }
            }
        
        case 'UPDATE_PASSPORT_STEP_SUCCESS':

            const items = state.items.map(step => { 
                if (step.id === action.id) return action.step; else return step  
            })

            return {
                ...state,
                updating:{
                    ...state.updating,
                    [action.id] : {
                        loading:false, 
                        isDone:true, 
                        errors:[] 
                    }
                },
                items
                
            }

        case 'UPDATE_PASSPORT_STEP_FAIL':
            return {
                ...state,
                updating:{
                    ...state.updating,
                    [action.id] : {
                        loading:false, 
                        isDone:false, 
                        errors:action.errors
                    }
                }
            }
        case 'DELETE_PASSPORT_STEP':
            return {
                ...state,
                deleting:{
                    ...state.deleting,
                    [action.id] : {
                        loading:true, 
                        errors:[] 
                    }
                }
            }
        
        case 'DELETE_PASSPORT_STEP_SUCCESS':

            return {
                ...state,
                deleting:{
                    ...state.deleting,
                    [action.id] : {
                        loading:false, 
                        errors:[] 
                    }
                },
                items:[...state.items.filter(o => o.id !== action.id)]
            }

        case 'DELETE_PASSPORT_STEP_FAIL':
            return {
                ...state,
                deleting:{
                    ...state.deleting,
                    [action.id] : {
                        loading:false, 
                        errors:action.errors
                    }
                }
            }
        case 'UNDO_PASSPORT_STEP':
            return {
                ...state,
                undo:{
                    ...state.undo,
                    [action.id] : {
                        loading:true, 
                        errors:[] 
                    }
                }
            }
        
        case 'UNDO_PASSPORT_STEP_SUCCESS':

            return {
                ...state,
                undo:{
                    ...state.undo,
                    [action.id] : {
                        loading:false, 
                        errors:[] 
                    }
                },
            }

        case 'UNDO_PASSPORT_STEP_FAIL':
            return {
                ...state,
                undo:{
                    ...state.undo,
                    [action.id] : {
                        loading:false, 
                        errors:action.errors
                    }
                }
            }
        case 'PUBLISH_ROUTE':
            return {
                ...state,
                publish:{
                    ...state.publish,
                    [action.identifier] : {
                        loading:true, 
                        errors:[] 
                    }
                }
            }
        
        case 'PUBLISH_ROUTE_SUCCESS':

            return {
                ...state,
                publish:{
                    ...state.publish,
                    [action.identifier] : {
                        loading:false, 
                        errors:[] 
                    }
                }
            }

        case 'PUBLISH_ROUTE_FAIL':
            return {
                ...state,
                publish:{
                    ...state.publish,
                    [action.identifier] : {
                        loading:false, 
                        errors:action.errors
                    }
                }
            }
        //request
        case 'REQUEST_PASSPORT_STEP_DATA':
            return {
                ...state,
                request:{
                    ...state.request,
                    [action.stepId] : {
                        loading:true, 
                        errors:[] 
                    }
                }
            }
        
        case 'REQUEST_PASSPORT_STEP_DATA_SUCCESS':

            return {
                ...state,
                request:{
                    ...state.request,
                    [action.stepId] : {
                        loading:false, 
                        errors:[] 
                    }
                }
            }

        case 'REQUEST_PASSPORT_STEP_DATA_FAIL':
            return {
                ...state,
                request:{
                    ...state.request,
                    [action.stepId] : {
                        loading:false, 
                        errors:action.errors
                    }
                }
            }
        // update cords
        case 'UPDATE_PASSPORT_STEP_CORDS':
          return {
              ...state,
              updating:{
                  ...state.updating,
                  [action.id] : {
                      loading:true, 
                      isDone:false, 
                      errors:[] 
                  }
              }
          }
      
        case 'UPDATE_PASSPORT_STEP_CORDS_SUCCESS':

          const cords = state.items.map(step => { 
              if (step.id === action.id) return action.step; else return step  
          })

          return {
              ...state,
              updating:{
                  ...state.updating,
                  [action.id] : {
                      loading:false, 
                      isDone:true, 
                      errors:[] 
                  }
              },
              cords
              
          }

        case 'UPDATE_PASSPORT_STEP_CORDS_FAIL':
          return {
              ...state,
              updating:{
                  ...state.updating,
                  [action.id] : {
                      loading:false, 
                      isDone:false, 
                      errors:action.errors
                  }
              }
          }

        case 'UPDATE_ROUTE_PAN_ZOOM':
            return {
                ...state,
                updating:{
                    ...state.updating,
                    [action.identifier] : {
                        loading:true, 
                        errors:[] 
                    }
                }
            }
        
        case 'UPDATE_ROUTE_PAN_ZOOM_SUCCESS':

            return {
                ...state,
                updating:{
                    ...state.updating,
                    [action.identifier] : {
                        loading:false, 
                        errors:[] 
                    }
                }
            }

        case 'UPDATE_ROUTE_PAN_ZOOM_FAIL':
            return {
                ...state,
                updating:{
                    ...state.updating,
                    [action.identifier] : {
                        loading:false, 
                        errors:action.errors
                    }
                }
          }
        //reset partner password
        case 'RESET_PARTNER_PASSWORD':
            return {
                ...state,
                reset_password:{
                    ...state.reset_password,
                    [action.partnerId] : {
                        loading:true, 
                        errors:[] 
                    }
                }
            }
        
        case 'RESET_PARTNER_PASSWORD_SUCCESS':

            return {
                ...state,
                reset_password:{
                    ...state.reset_password,
                    [action.partnerId] : {
                        loading:false, 
                        errors:[] 
                    }
                }
            }

        case 'RESET_PARTNER_PASSWORD_FAIL':
            return {
                ...state,
                reset_password:{
                    ...state.reset_password,
                    [action.partnerId] : {
                        loading:false, 
                        errors:action.errors
                    }
                }
            }
    //reset partner password
        case 'RESET_PARTNER_PASSWORD':
            return {
                ...state,
                reset_password:{
                    ...state.reset_password,
                    [action.partnerId] : {
                        loading:true, 
                        errors:[] 
                    }
                }
            }
        
        case 'RESET_PARTNER_PASSWORD_SUCCESS':

            return {
                ...state,
                reset_password:{
                    ...state.reset_password,
                    [action.partnerId] : {
                        loading:false, 
                        errors:[] 
                    }
                }
            }

        case 'RESET_PARTNER_PASSWORD_FAIL':
            return {
                ...state,
                reset_password:{
                    ...state.reset_password,
                    [action.partnerId] : {
                        loading:false, 
                        errors:action.errors
                    }
                }
            }
        //delete partner request
        case 'DELETE_PARTNER_REQUEST':
            return {
                ...state,
                delete_partner:{
                    ...state.delete_partner,
                    [action.partnerId] : {
                        loading:true, 
                        errors:[] 
                    }
                }
            }
        
        case 'DELETE_PARTNER_REQUEST_SUCCESS':

            return {
                ...state,
                delete_partner:{
                    ...state.delete_partner,
                    [action.partnerId] : {
                        loading:false, 
                        errors:[] 
                    }
                }
            }

        case 'DELETE_PARTNER_REQUEST_FAIL':
            return {
                ...state,
                delete_partner:{
                    ...state.delete_partner,
                    [action.partnerId] : {
                        loading:false, 
                        errors:action.errors
                    }
                }
            }

        //apply for certification
        case 'APPLY_STEP_CERTIFICATION':
            return {
                ...state,
                apply:{
                    ...state.apply,
                    [action.stepId] : {
                        loading:true, 
                        errors:[] 
                    }
                }
            }
        
        case 'APPLY_STEP_CERTIFICATION_SUCCESS':

            return {
                ...state,
                apply:{
                    ...state.apply,
                    [action.stepId] : {
                        loading:false, 
                        errors:[] 
                    }
                }
            }

        case 'APPLY_STEP_CERTIFICATION_FAIL':
            return {
                ...state,
                apply:{
                    ...state.apply,
                    [action.stepId] : {
                        loading:false, 
                        errors:action.errors
                    }
                }
            }

        //certify
        case 'DO_CERTIFICATION':
            return {
                ...state,
                certify:{
                    ...state.certify,
                    [action.stepId] : {
                        loading:true, 
                        isDone:false,
                        errors:[] 
                    }
                }
            }
        
        case 'DO_CERTIFICATION_SUCCESS':

            return {
                ...state,
                certify:{
                    ...state.certify,
                    [action.stepId] : {
                        loading:false, 
                        isDone:true,
                        errors:[] 
                    }
                }
            }

        case 'DO_CERTIFICATION_FAIL':
            return {
                ...state,
                certify:{
                    ...state.certify,
                    [action.stepId] : {
                        loading:false, 
                        isDone:false,
                        errors:action.errors
                    }
                }
            }

        //receive
        case 'RECEIVE_ASSET':
            return {
                ...state,
                receive:{
                    ...state.receive,
                    [action.stepId] : {
                        loading:true, 
                        isDone:false,
                        errors:[] 
                    }
                }
            }
        
        case 'RECEIVE_ASSET_SUCCESS':

            return {
                ...state,
                receive:{
                    ...state.receive,
                    [action.stepId] : {
                        loading:false, 
                        isDone:true,
                        errors:[] 
                    }
                }
            }

        case 'RECEIVE_ASSET_FAIL':
            return {
                ...state,
                receive:{
                    ...state.receive,
                    [action.stepId] : {
                        loading:false, 
                        isDone:false,
                        errors:action.errors
                    }
                }
            }
        default:
        return state
    }
}

export default passportReducer